import { EXERCISE_TYPE, ROUTES, LOGGER_EVENTS } from "@tt-app/constants";
const { EXERCISE } = ROUTES;
import { logger } from "../../../utils";
import router from "../../../router";

const GoToExerciseMixin = {
  methods: {
    goToExerciseFromLog(log) {
      // used in RecentExerciseList
      const type = log.exercise.type;

      const params = {
        courseUuid: log.course.uuid,
        exerciseType: type,
        exerciseUuid: log.exercise.uuid
      };
      if (log.assignment?.id) {
        params.assignmentId = log.assignment.id;
      }
      this.goToExercise(params, type);
    },
    goToExerciseFromExerciseEntry(exercise, assignmentId = null, explicitCourseUuid = null) {
      // used in ExerciseList, AssignmentDetail
      const type = exercise.type || exercise.exerciseType;
      const courseUuid = explicitCourseUuid || exercise.courseUuid;
      const params = {
        courseUuid: courseUuid,
        exerciseType: type,
        exerciseUuid: exercise.uuid
      };
      if (assignmentId) {
        params.assignmentId = assignmentId;
      }

      this.goToExercise(params, type);
    },
    goToExercise(params, type) {
      switch (type) {
        case EXERCISE_TYPE.CHAT:
          router.push({
            name: EXERCISE.CHAT.NAME,
            params
          });
          break;
        case EXERCISE_TYPE.DEMO_LISTENING:
          router.push({
            name: EXERCISE.DEMO.NAME,
            params
          });
          break;
        case EXERCISE_TYPE.DICTATION:
          router.push({
            name: EXERCISE.DICTATION.NAME,
            params
          });
          break;
        case EXERCISE_TYPE.DRILL_PRONUNCIATION:
          logger.logEvent(LOGGER_EVENTS.USER.EXERCISE_OPEN.SUCCESS, { ...params });

          router.push({
            name: EXERCISE.DRILL_PRONUNCIATION.NAME,
            params
          });
          break;
        case EXERCISE_TYPE.DRILL_LISTENING:
          router.push({
            name: EXERCISE.DRILL_LISTENING.NAME,
            params
          });
          break;
        case EXERCISE_TYPE.DRILL_VOCABULARY:
          router.push({
            name: EXERCISE.DRILL_VOCABULARY.NAME,
            params
          });
          break;
        case EXERCISE_TYPE.QUIZ_LISTENING:
          router.push({
            name: EXERCISE.QUIZ_LISTENING.NAME,
            params
          });
          break;
        case EXERCISE_TYPE.PICTURE_MATCH:
          router.push({
            name: EXERCISE.PICTURE_MATCH.NAME,
            params
          });
          break;
        case EXERCISE_TYPE.DRILL_TYPING:
          router.push({
            name: EXERCISE.DRILL_TYPING.NAME,
            params
          });
          break;
        case EXERCISE_TYPE.SINGLE_SENTENCE_READING:
          router.push({
            name: EXERCISE.SINGLE_SENTENCE_READING.NAME,
            params
          });
          break;
        case EXERCISE_TYPE.QUIZ_TRANSLATION:
          router.push({
            name: EXERCISE.QUIZ_TRANSLATION.NAME,
            params
          });
          break;
        case EXERCISE_TYPE.DRILL_TRANSLATION:
          router.push({
            name: EXERCISE.DRILL_TRANSLATION.NAME,
            params
          });
          break;
        default:
          router.push({
            name: EXERCISE.EXERCISE_ROOT.NAME,
            params
          });
      }
    }
  }
};

export default GoToExerciseMixin;
